import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Deposito } from "@/shared/types/deposito";

export async function getDeposito(id: string): Promise<Deposito> {
    await sleep(1000);
    const response = await api.get("depositos/" + id);
    return response.data;
}

export function useGetDepositoQuery(id: string, queryConfig: QueryConfig<Deposito> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getDeposito(id),
        queryKey: ["depositos", id],
    })
}

export interface GetDepositoQueryProps {
    id: string,
    queryConfig?: QueryConfig<Deposito>,
    children?: (queryResult: QueryResult<Deposito>) => ReactNode
}

export function GetDepositoQuery({
    id,
    children,
    queryConfig
}: GetDepositoQueryProps) {
    const queryResult = useGetDepositoQuery(id, queryConfig);
    return children && children(queryResult);
}
